{
  "MACROS": {
    "HEADER": "Macros",
    "DESCRIPTION": "Uma macro é um conjunto de ações guardadas que ajudam os agentes de apoio ao cliente a completarem tarefas facilmente. Os agentes podem definir um conjunto de ações, como adicionar uma etiqueta a uma conversa, enviar uma transcrição de e-mail, atualizar um atributo personalizado, etc., e, posteriormente, executarem essas ações com um único clique.",
    "LEARN_MORE": "Saber mais sobre macros",
    "HEADER_BTN_TXT": "Adicionar nova macro",
    "HEADER_BTN_TXT_SAVE": "Guardar macro",
    "LOADING": "A procurar macros",
    "ERROR": "Ocorreu um erro! Por favor, tente novamente",
    "ORDER_INFO": "As macros serão executadas pela ordem em que adicionar as suas ações. Pode reorganizá-las arrastando-as pelo identificador ao lado de cada nó.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Nome da macro",
          "PLACEHOLDER": "Insira um nome para a macro",
          "ERROR": "O nome é obrigatório para criar uma macro"
        },
        "ACTIONS": {
          "LABEL": "Ações"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro adicionada com sucesso",
        "ERROR_MESSAGE": "Não foi possível criar a macro. Por favor, tente novamente mais tarde"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nome:",
        "CREATED BY": "Criada por",
        "LAST_UPDATED_BY": "Ultima atualização por",
        "VISIBILITY": "Visibilidade"
      },
      "404": "Nenhuma macro encontrada"
    },
    "DELETE": {
      "TOOLTIP": "Apagar macro",
      "CONFIRM": {
        "MESSAGE": "Tem a certeza que pretende excluir ",
        "YES": "Sim, excluir",
        "NO": "Não, manter"
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro excluída com sucesso",
        "ERROR_MESSAGE": "Ocorreu um erro ao excluir a macro. Por favor, tente novamente mais tarde"
      }
    },
    "EDIT": {
      "TOOLTIP": "Editar macro",
      "API": {
        "SUCCESS_MESSAGE": "Macro atualizada com sucesso",
        "ERROR_MESSAGE": "Não foi possível atualizar a macro. Por favor, tente novamente mais tarde"
      }
    },
    "EDITOR": {
      "START_FLOW": "Início do fluxo",
      "END_FLOW": "Fim do fluxo",
      "LOADING": "A obter macro",
      "ADD_BTN_TOOLTIP": "Adicionar nova ação",
      "DELETE_BTN_TOOLTIP": "Excluir ação",
      "VISIBILITY": {
        "LABEL": "Visibilidade da macro",
        "GLOBAL": {
          "LABEL": "Pública",
          "DESCRIPTION": "Esta macro está disponível publicamente para todos os agentes nesta conta."
        },
        "PERSONAL": {
          "LABEL": "Privada",
          "DESCRIPTION": "Esta macro será para sua utilização exclusiva e não estará disponível para outras pessoas."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Executar",
      "PREVIEW": "Pré-visualizar macro",
      "EXECUTED_SUCCESSFULLY": "Macro executada com sucesso"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Chave do atributo necessária",
      "FILTER_OPERATOR_REQUIRED": "Operador do filtro necessário",
      "VALUE_REQUIRED": "Valor obrigatório",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "O valor deve ser entre 1 e 998",
      "ACTION_PARAMETERS_REQUIRED": "Parâmetros de ação obrigatórios",
      "ATLEAST_ONE_CONDITION_REQUIRED": "Pelo menos uma condição é obrigatória",
      "ATLEAST_ONE_ACTION_REQUIRED": "Pelo menos uma ação é obrigatória"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Atribuir uma equipa",
      "ASSIGN_AGENT": "Atribuir um agente",
      "ADD_LABEL": "Adicionar uma etiqueta",
      "REMOVE_LABEL": "Remover uma etiqueta",
      "REMOVE_ASSIGNED_TEAM": "Remover equipa atribuída",
      "SEND_EMAIL_TRANSCRIPT": "Enviar uma transcrição por e-mail",
      "MUTE_CONVERSATION": "Silenciar conversa",
      "SNOOZE_CONVERSATION": "Adiar conversa",
      "RESOLVE_CONVERSATION": "Resolver conversa",
      "SEND_ATTACHMENT": "Enviar anexo",
      "SEND_MESSAGE": "Enviar uma mensagem",
      "CHANGE_PRIORITY": "Alterar prioridade",
      "ADD_PRIVATE_NOTE": "Adicionar uma nota privada",
      "SEND_WEBHOOK_EVENT": "Enviar evento de webhook"
    },
    "ACTION_VALUES": {
      "SELF": "Eu mesmo"
    }
  }
}
